export interface WhatsAppConfig {
  apiKey: string;
  phoneNumberId: string;
}

export class WhatsAppAPI {
  private config: WhatsAppConfig;
  private readonly baseUrl = 'https://api.kapso.ai/meta/whatsapp/v24.0';

  constructor(config: WhatsAppConfig) {
    this.config = config;
  }

  async sendMessage(to: string, message: string): Promise<any> {
    const response = await fetch(
      `${this.baseUrl}/${this.config.phoneNumberId}/messages`,
      {
        method: 'POST',
        headers: {
          'X-API-Key': this.config.apiKey,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          messaging_product: 'whatsapp',
          to: to.replace(/\D/g, ''),
          type: 'text',
          text: { body: message },
        }),
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error?.message || `Erro ao enviar mensagem (${response.status})`);
    }

    return response.json();
  }

  validatePhoneNumber(phone: string): { valid: boolean; formatted?: string; message?: string } {
    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.length < 10 || cleaned.length > 15) {
      return { valid: false, message: 'Número deve ter entre 10 e 15 dígitos' };
    }

    if (!cleaned.startsWith('55')) {
      return { valid: false, message: 'Para números brasileiros, use o código do país (55)' };
    }

    return { valid: true, formatted: `+${cleaned}` };
  }
}
